// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z59G","label":"styles_label__3QMt1"};